import React from 'react';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const socialLinks = [
    {
      icon: "Github",
      label: "GitHub",
      url: "https://github.com/tharsh95"
    },
    {
      icon: "Linkedin",
      label: "LinkedIn", 
      url: "https://www.linkedin.com/in/harsh-tiwari-a5531815a"
    },
    {
      icon: "Mail",
      label: "Email",
      url: "mailto:harsh.tiwari1995@gmail.com"
    }
  ];

  const quickLinks = [
    { name: "About", href: "#about" },
    { name: "Skills", href: "#skills" },
    { name: "Experience", href: "#experience" },
    { name: "Projects", href: "#projects" },
    { name: "Contact", href: "#contact" }
  ];

  const handleSmoothScroll = (href) => {
    if (href?.startsWith('#')) {
      const element = document.getElementById(href?.substring(1));
      if (element) {
        element?.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="w-full max-w-6xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Brand Section */}
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
                  <Icon name="Code2" size={20} color="white" strokeWidth={2.5} />
                </div>
                <span className="text-xl font-bold text-foreground">
                  DevPortfolio Pro
                </span>
              </div>
              <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
                Full-Stack Developer specializing in MERN stack technologies. 
                Building scalable web applications with modern tools and best practices.
              </p>
              <div className="flex space-x-3">
                {socialLinks?.map((social, index) => (
                  <a
                    key={index}
                    href={social?.url}
                    target={social?.url?.startsWith('mailto:') ? undefined : '_blank'}
                    rel={social?.url?.startsWith('mailto:') ? undefined : 'noopener noreferrer'}
                    className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-primary hover:text-white transition-all duration-200"
                    aria-label={social?.label}
                  >
                    <Icon name={social?.icon} size={18} />
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="space-y-4">
              <h3 className="font-semibold text-foreground">Quick Links</h3>
              <nav className="space-y-2">
                {quickLinks?.map((link, index) => (
                  <button
                    key={index}
                    onClick={() => handleSmoothScroll(link?.href)}
                    className="block text-muted-foreground hover:text-primary transition-colors duration-200 text-sm"
                  >
                    {link?.name}
                  </button>
                ))}
              </nav>
            </div>

            {/* Contact Info */}
            <div className="space-y-4">
              <h3 className="font-semibold text-foreground">Get In Touch</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <Icon name="Mail" size={16} className="text-primary" />
                  <a 
                    href="mailto:harsh.tiwari1995@gmail.com"
                    className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm"
                  >
                    harsh.tiwari1995@gmail.com
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Icon name="Phone" size={16} className="text-primary" />
                  <a 
                    href="tel:+919663896862"
                    className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm"
                  >
                    +91 9663896862
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Icon name="MapPin" size={16} className="text-primary" />
                  <span className="text-muted-foreground text-sm">
                    Lucknow, India
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-6 border-t border-border">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="text-sm text-muted-foreground">
              © {currentYear} DevPortfolio Pro. All rights reserved.
            </div>
            
            <div className="flex items-center space-x-6">
              <button
                onClick={scrollToTop}
                className="flex items-center space-x-2 text-muted-foreground hover:text-primary transition-colors duration-200 text-sm"
              >
                <Icon name="ArrowUp" size={16} />
                <span>Back to Top</span>
              </button>
            </div>
          </div>
        </div>

        {/* Additional Footer Note */}
        <div className="pb-6">
          <div className="text-center">
            <p className="text-xs text-muted-foreground">
              Built with React, Tailwind CSS, and lots of ☕
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;